// extracted by mini-css-extract-plugin
module.exports = {"screen":"screen__6UxbnQG8mZD+2","title":"title__1kmnfmk6x3sFo","paginatorWrap":"paginatorWrap__o8VhbBgZNoUre"};